export default __webpack_public_path__ + "static/media/for-business-box--rounded.321ddc2e.svg";